// src/components/RGPForm.js
import React, { useState } from 'react';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import Button from '../ui/Button'

const WORK_NATURE_OPTIONS = {
    inward: ['wirecut', 'stone', 'calibration', 'toolRoomWork'],
    outward: ['hardening', 'coating', 'partsCutting']
};

const RGPForm = ({ onSubmit, initialData = {}, onCancel, edit, mode }) => {
    const [formData, setFormData] = useState({
        ...initialData,
        openingDate: initialData.openingDate ? new Date(initialData.openingDate) : new Date(),
        // openingDate: initialData.openingDate ? new Date(initialData.openingDate) : new Date(),
        closureDate: initialData.closureDate ? new Date(initialData.closureDate) : null,
        expectedClosureDate: initialData.expectedClosureDate ? new Date(initialData.expectedClosureDate) : null,
        items: initialData.items || [{
            itemDescription: '',
            itemCode: '',
            itemPrice: '',
            itemUnit: '',
            quantity: 1,
            natureOfWork: []
        }]
        // natureOfWork: initialData.natureOfWork || {
        //     wirecut: false,
        //     stone: false,
        //     calibration: false,
        //     toolroomwork: false,
        //     hardening: false,
        //     coating: false,
        //     partsCutting: false
        // }
    });

    const [activeTab, setActiveTab] = useState(
        initialData.customerName ? 'inward' : initialData.vendorName ? 'outward' : 'inward'
    );

    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;
        setFormData(prev => ({
        ...prev,
        [name]: type === 'checkbox' ? checked : value
        }));
    };

    const handleItemChange = (index, e) => {
        const { name, value } = e.target;
        const newItems = [...formData.items];
        newItems[index] = {
          ...newItems[index],
          [name]: name === 'quantity' ? parseInt(value) || 0 : value
        };
        setFormData(prev => ({ ...prev, items: newItems }));
    };

    // const handleWorkNatureChange = (e) => {
    //     const { name, checked } = e.target;
    //     setFormData(prev => ({
    //     ...prev,
    //     natureOfWork: {
    //         ...prev.natureOfWork,
    //         [name]: checked
    //     }
    //     }));
    // };

    const handleWorkNatureChange = (itemIndex, workNature) => {
        const newItems = [...formData.items];
        const currentNatures = newItems[itemIndex].natureOfWork;
        
        if (currentNatures.includes(workNature)) {
          newItems[itemIndex].natureOfWork = currentNatures.filter(n => n !== workNature);
        } else {
          newItems[itemIndex].natureOfWork = [...currentNatures, workNature];
        }
        
        setFormData(prev => ({ ...prev, items: newItems }));
    };

    const addItem = () => {
        setFormData(prev => ({
          ...prev,
          items: [
            ...prev.items,
            {
                itemDescription: '',
                itemCode: '',
                itemPrice: '',
                itemUnit: '',
                quantity: 1,
                natureOfWork: []
            }
          ]
        }));
    };

    const removeItem = (index) => {
        const newItems = [...formData.items];
        newItems.splice(index, 1);
        setFormData(prev => ({ ...prev, items: newItems }));
    };

    const handleDateChange = (date, field) => {
        setFormData(prev => ({ ...prev, [field]: date }));
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        onSubmit(formData);
    };

    return (
        <form id="rgpForm" onSubmit={handleSubmit} className="space-y-4 h-[100%] overflow-auto">
            {!edit ?
            <div className="border-b border-gray-200">
                <nav className="-mb-px flex space-x-8">
                <button
                    type="button"
                    className={`${activeTab === 'inward' ? 'border-blue-500 bg-blue-600 text-white px-4' : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'} whitespace-nowrap py-2 px-1 border-b-2 font-medium text-sm focus:outline-none rounded`}
                    onClick={() => setActiveTab('inward')}
                >
                    Inward RGP
                </button>
                <button
                    type="button"
                    className={`${activeTab === 'outward' ? 'border-blue-500 bg-blue-600 text-white px-4' : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'} whitespace-nowrap py-2 px-1 border-b-2 font-medium text-sm focus:outline-none rounded`}
                    onClick={() => setActiveTab('outward')}
                >
                    Outward RGP
                </button>
                </nav>
            </div>
            : <></>
            }

            <div className="grid grid-cols-1 md:grid-cols-4 gap-4">
                <div>
                    <span className="text-sm font-medium text-gray-500">RGP Number:</span>
                    <span className="ml-2 text-sm font-semibold">
                    {formData.rgpNumber || 'Will be generated'}
                    </span>
                </div>

                <div>
                <label htmlFor="openingDate" className="inline-block text-sm font-medium text-gray-700">
                    Opening Date *
                </label>
                <DatePicker
                    selected={formData.openingDate}
                    dateFormat={'dd-MM-yyyy'}
                    onChange={(date) => handleDateChange(date, 'openingDate')}
                    placeholderText='dd-MM-yyyy'
                    className="ml-2 w-28 inline-block border border-gray-300 rounded-md shadow-sm py-1 px-2 text-center focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
                    required
                    disabled={mode === 'view'}
                />
                </div>

                <div>
                    <label htmlFor="expectedClosureDate" className="inline-block text-sm font-medium text-gray-700">
                        Expected Date *
                    </label>
                    <DatePicker
                        selected={formData.expectedClosureDate}
                        dateFormat={'dd-MM-yyyy'}
                        onChange={(date) => handleDateChange(date, 'expectedClosureDate')}
                        placeholderText='dd-mm-yyyy'
                        className="ml-2 w-28 inline-block border border-gray-300 rounded-md shadow-sm py-1 px-2 text-center focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
                        disabled={mode === 'view'}
                        required
                    />
                </div>

                {activeTab === 'inward' ? (
                <>
                <div className='text-right text-xs font-bold'>
                    {edit ? 'Inward' : '' }
                    <span className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${getStatusBadgeColor(formData.status)}`}>
                        {formData.status || 'Open'}
                    </span>
                </div>

                <div>
                    <label htmlFor="customerName" className="block text-sm font-medium text-gray-700">
                        Customer Name *
                    </label>
                    <input
                        type="text"
                        name="customerName"
                        id="customerName"
                        value={formData.customerName || ''}
                        onChange={handleChange}
                        className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
                        disabled={mode === 'view'}
                        required
                    />
                </div>

                <div>
                    <label htmlFor="assignedPerson" className="block text-sm font-medium text-gray-700">
                        Assigned Person *
                    </label>
                    <input
                        type="text"
                        name="assignedPerson"
                        id="assignedPerson"
                        value={formData.assignedPerson || ''}
                        onChange={handleChange}
                        className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
                        disabled={mode === 'view'}
                        required
                    />
                </div>

                {/* <div className="col-span-1 row-span-2">
                    <label className="block text-sm font-medium text-gray-700">
                        Nature of Work *
                    </label>

                    <div className="grid grid-cols-1 sm:grid-cols-2 gap-2">
                        <div className="flex items-center">
                            <input
                                type="checkbox"
                                name="wirecut"
                                id="wirecut"
                                checked={formData.natureOfWork.wirecut || false}
                                onChange={handleWorkNatureChange}
                                className="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded"
                            />
                            <label htmlFor="wirecut" className="ml-2 mb-0 block text-sm text-gray-700">
                                Wire Cut
                            </label>
                        </div>
                        <div className="flex items-center">
                            <input
                                type="checkbox"
                                name="stone"
                                id="stone"
                                checked={formData.natureOfWork.stone || false}
                                onChange={handleWorkNatureChange}
                                className="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded"
                            />
                            <label htmlFor="stone" className="ml-2 mb-0 block text-sm text-gray-700">
                                Stone
                            </label>
                        </div>
                        <div className="flex items-center">
                            <input
                                type="checkbox"
                                name="calibration"
                                id="calibration"
                                checked={formData.natureOfWork.calibration || false}
                                onChange={handleWorkNatureChange}
                                className="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded"
                            />
                            <label htmlFor="calibration" className="ml-2 mb-0 block text-sm text-gray-700">
                                Calibration
                            </label>
                        </div>
                        <div className="flex items-center">
                            <input
                                type="checkbox"
                                name="toolroomwork"
                                id="toolroomwork"
                                checked={formData.natureOfWork.toolroomwork || false}
                                onChange={handleWorkNatureChange}
                                className="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded"
                            />
                            <label htmlFor="toolroomwork" className="ml-2 mb-0 block text-sm text-gray-700">
                                Tool Room Work
                            </label>
                        </div>
                    </div>
                    
                    <select
                        name="natureOfWork"
                        id="natureOfWork"
                        value={formData.natureOfWork || ''}
                        onChange={handleChange}
                        className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
                        required
                    >
                        <option value="">Select...</option>
                        <option value="Wire Cut">Wire Cut</option>
                        <option value="Stone">Stone</option>
                        <option value="Calibration">Calibration</option>
                        <option value="Tool Room Work">Tool Room Work</option>
                    </select>
                </div> */}

                </>
                ) : (
                <>
                {/* <div>
                    <label htmlFor="openingDate" className="block text-sm font-medium text-gray-700">
                        Outward Date *
                    </label>
                    <DatePicker
                        selected={formData.openingDate}
                        onChange={(date) => handleDateChange(date, 'openingDate')}
                        className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
                        required
                    />
                </div> */}
                <div className='text-right text-xs font-bold'>
                    {edit ? 'Outward' : '' }
                    <span className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${getStatusBadgeColor(formData.status)}`}>
                        {formData.status || 'Open'}
                    </span>
                </div>


                <div>
                    <label htmlFor="vendorName" className="block text-sm font-medium text-gray-700">
                        Vendor Name *
                    </label>
                    <input
                        type="text"
                        name="vendorName"
                        id="vendorName"
                        value={formData.vendorName || ''}
                        onChange={handleChange}
                        className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
                        disabled={mode === 'view'}
                        required
                    />
                </div>

                <div>
                    <label htmlFor="concernedPerson" className="block text-sm font-medium text-gray-700">
                        Concerned Person *
                    </label>
                    <input
                        type="text"
                        name="concernedPerson"
                        id="concernedPerson"
                        value={formData.concernedPerson || ''}
                        onChange={handleChange}
                        className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
                        disabled={mode === 'view'}
                        required
                    />
                </div>

                {/* <div className="col-span-1 row-span-2">
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                        Nature of Work *
                    </label>
                    <div className="grid grid-cols-1 sm:grid-cols-2 gap-2">
                        <div className="flex items-center">
                        <input
                            type="checkbox"
                            name="hardening"
                            id="hardening"
                            checked={formData.natureOfWork.hardening || false}
                            onChange={handleWorkNatureChange}
                            className="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded"
                        />
                        <label htmlFor="hardening" className="ml-2 mb-0 block text-sm text-gray-700">
                            Hardening
                        </label>
                        </div>
                        <div className="flex items-center">
                        <input
                            type="checkbox"
                            name="coating"
                            id="coating"
                            checked={formData.natureOfWork.coating || false}
                            onChange={handleWorkNatureChange}
                            className="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded"
                        />
                        <label htmlFor="coating" className="ml-2 mb-0 block text-sm text-gray-700">
                            Coating
                        </label>
                        </div>
                        <div className="flex items-center">
                        <input
                            type="checkbox"
                            name="partsCutting"
                            id="partsCutting"
                            checked={formData.natureOfWork.partsCutting || false}
                            onChange={handleWorkNatureChange}
                            className="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded"
                        />
                        <label htmlFor="partsCutting" className="ml-2 mb-0 block text-sm text-gray-700">
                            Parts Cutting
                        </label>
                        </div>
                    </div>
                </div> */}

                </>
                )}

                <div>
                    <label htmlFor="challanNumber" className="block text-sm font-medium text-gray-700">
                        Challan Number
                    </label>
                    <input
                        type="text"
                        name="challanNumber"
                        id="challanNumber"
                        value={formData.challanNumber || ''}
                        onChange={handleChange}
                        className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
                        disabled={mode === 'view'}
                        // required
                    />
                </div>

                <div>
                    <label htmlFor="billNumber" className="block text-sm font-medium text-gray-700">
                        Bill Number
                    </label>
                    <input
                        type="text"
                        name="billNumber"
                        id="billNumber"
                        value={formData.billNumber || ''}
                        onChange={handleChange}
                        className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
                        disabled={mode === 'view'}
                        // required
                    />
                </div>

                {/* <h3 className="text-lg font-medium">Items</h3> */}
                <div className="px-2 pt-2 col-span-4">
                    <div className="grid grid-cols-1 md:grid-cols-8 gap-4">
                        <div className='col-span-2'>
                            <label htmlFor={`itemDescription`} className="block text-sm font-medium text-gray-700 mb-0">
                            Item Description *
                            </label>
                        </div>
                        <div>
                            <label htmlFor={`quantity`} className="block text-sm font-medium text-gray-700 mb-0">
                            Quantity *
                            </label>
                        </div>
                        <div>
                            <label htmlFor={`quantity`} className="block text-sm font-medium text-gray-700 mb-0">
                            Item Unit *
                            </label>
                        </div>
                        <div>
                            <label htmlFor={`quantity`} className="block text-sm font-medium text-gray-700 mb-0">
                            Item Code
                            </label>
                        </div>
                        <div>
                            <label htmlFor={`quantity`} className="block text-sm font-medium text-gray-700 mb-0">
                            Item Price
                            </label>
                        </div>
                        <div className='col-span-2'>
                            <label htmlFor={`itemDescription`} className="block text-sm font-medium text-gray-700 mb-0">
                            Nature of Work *
                            </label>
                        </div>
                    </div>
                </div>
                <div className="space-y-2 col-span-4">
                    <div className='max-h-[200px] overflow-auto'>
                    {formData.items.map((item, itemIndex) => (
                    <div key={itemIndex} className="bg-gray-100 p-2 mb-1 rounded-lg relative">
                        {formData.items.length > 1 && (
                        <Button
                            type="button"
                            onClick={() => removeItem(itemIndex)}
                            className="absolute top-2 right-2 text-red-500 hover:text-red-700"
                        >
                            x
                        </Button>
                        )}

                        <div className="grid grid-cols-1 md:grid-cols-8 gap-4 align-items-center">
                        {/* Item description and quantity fields */}
                        <div className='col-span-2'>
                            {/* <label htmlFor={`itemDescription-${itemIndex}`} className="block text-sm font-medium text-gray-700">
                            Item Description *
                            </label> */}
                            <input
                            type="text"
                            name="itemDescription"
                            id={`itemDescription-${itemIndex}`}
                            value={item.itemDescription}
                            onChange={(e) => handleItemChange(itemIndex, e)}
                            className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
                            disabled={mode === 'view'}
                            required
                            />
                        </div>

                        <div>
                            {/* <label htmlFor={`quantity-${itemIndex}`} className="block text-sm font-medium text-gray-700">
                            Quantity *
                            </label> */}
                            <input
                            type="number"
                            name="quantity"
                            id={`quantity-${itemIndex}`}
                            min="1"
                            value={item.quantity}
                            onChange={(e) => handleItemChange(itemIndex, e)}
                            className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
                            disabled={mode === 'view'}
                            required
                            />
                        </div>

                        <div>
                            {/* <label htmlFor={`itemUnit-${itemIndex}`} className="block text-sm font-medium text-gray-700">
                            Item Unit *
                            </label> */}
                            <input
                            type="text"
                            name="itemUnit"
                            id={`itemUnit-${itemIndex}`}
                            min="1"
                            value={item.itemUnit}
                            onChange={(e) => handleItemChange(itemIndex, e)}
                            className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
                            disabled={mode === 'view'}
                            required
                            />
                        </div>

                        <div>
                            {/* <label htmlFor={`itemCode-${itemIndex}`} className="block text-sm font-medium text-gray-700">
                            Item Code
                            </label> */}
                            <input
                            type="text"
                            name="itemCode"
                            id={`itemCode-${itemIndex}`}
                            min="1"
                            value={item.itemCode}
                            onChange={(e) => handleItemChange(itemIndex, e)}
                            className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
                            disabled={mode === 'view'}
                            />
                        </div>

                        <div>
                            {/* <label htmlFor={`itemPrice-${itemIndex}`} className="block text-sm font-medium text-gray-700">
                            Item Price
                            </label> */}
                            <input
                            type="text"
                            name="itemPrice"
                            id={`itemPrice-${itemIndex}`}
                            min="1"
                            value={item.itemPrice}
                            onChange={(e) => handleItemChange(itemIndex, e)}
                            className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
                            disabled={mode === 'view'}
                            />
                        </div>

                        {/* Nature of Work section */}
                        <div className="col-span-2">
                            {/* <label className="block text-sm font-medium text-gray-700 mb-2">
                            Nature of Work *
                            </label> */}
                            
                            {/* Standard options */}
                            <div className="grid grid-cols-1 sm:grid-cols-2 gap-2 mb-0">
                            {WORK_NATURE_OPTIONS[activeTab].map((workNature) => (
                                <div key={workNature} className="flex items-center">
                                <input
                                    type="checkbox"
                                    id={`${workNature}-${itemIndex}`}
                                    checked={item.natureOfWork.includes(workNature)}
                                    onChange={() => handleWorkNatureChange(itemIndex, workNature)}
                                    className="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded"
                                    disabled={mode === 'view'}
                                />
                                <label htmlFor={`${workNature}-${itemIndex}`} className="ml-2 mb-0 block capitalize text-xs text-gray-700">
                                    {workNature.split(/(?=[A-Z])/).join(' ')}
                                </label>
                                </div>
                            ))}
                            </div>

                        </div>
                        </div>
                    </div>
                    ))}
                    </div>

                    {mode !== 'view' && (
                        <div className="text-right">
                    <button
                    type="button"
                    onClick={addItem}
                    className="px-2 py-1 bg-blue-50 text-blue-500 rounded-md hover:bg-blue-600 hover:text-white focus:outline-none"
                    >
                    <svg xmlns="http://www.w3.org/2000/svg" className="inline h-5 w-5 mr-1" viewBox="0 0 20 20" fill="currentColor">
                        <path fillRule="evenodd" d="M10 5a1 1 0 011 1v3h3a1 1 0 110 2h-3v3a1 1 0 11-2 0v-3H6a1 1 0 110-2h3V6a1 1 0 011-1z" clipRule="evenodd" />
                    </svg>
                    Item
                    </button>
                    </div>
                    )}
                </div>

                {/* Common fields */}

                {/* <div>
                    <label htmlFor="itemDescription" className="block text-sm font-medium text-gray-700">
                        Item Description
                    </label>
                    <input
                        type="text"
                        name="itemDescription"
                        id="itemDescription"
                        value={formData.itemDescription || ''}
                        onChange={handleChange}
                        className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
                    />
                </div>
                <div>
                    <label htmlFor="quantity" className="block text-sm font-medium text-gray-700">
                        Quantity *
                    </label>
                    <input
                        type="number"
                        name="quantity"
                        id="quantity"
                        min="1"
                        value={formData.quantity || ''}
                        onChange={handleChange}
                        className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
                        required
                    />
                </div> */}


                <div className='col-span-4'>
                    <div className="grid grid-cols-1 md:grid-cols-4 gap-4 align-items-end">

                        <div className='col-span-2'>
                            <label htmlFor="remarks" className="block text-sm font-medium text-gray-700">
                                Remarks
                            </label>
                            <textarea
                                name="remarks"
                                id="remarks"
                                rows={1}
                                value={formData.remarks || ''}
                                onChange={handleChange}
                                className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
                                disabled={mode === 'view'}
                            />
                        </div>

                        <div>

                        {edit ? 
                        <div>
                            <label htmlFor="expectedClosureDate" className="block text-sm font-medium text-gray-700">
                                Closing Date
                            </label>
                            <DatePicker
                                selected={formData.closureDate}
                                dateFormat={'dd-MM-yyyy'}
                                onChange={(date) => handleDateChange(date, 'closureDate')}
                                placeholderText='dd-mm-yyyy'
                                className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
                                disabled={mode === 'view'}
                            />
                        </div>
                    
                        :
                        <></>
                        }
                        </div>

                        {mode !== 'view' && (
                        <div className="text-right bottom-0">
                            <button
                            type="button"
                            className="w-full inline-flex justify-center rounded-md border border-gray-300 shadow-sm px-4 py-2 bg-white text-base font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 sm:mt-0 sm:ml-3 sm:w-auto sm:text-sm"
                            onClick={onCancel}
                            >
                            Cancel
                            </button>
                            <button
                            type="submit"
                            className="w-full inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 bg-blue-600 text-base font-medium text-white hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 sm:ml-3 sm:w-auto sm:text-sm"
                            form="rgpForm"
                            >
                            Save
                            </button>
                        </div>
                        )}
                    </div>
                </div>
            </div>

        </form>
    );
};

function getStatusBadgeColor(status) {
    switch (status) {
        case 'Completed': return 'bg-green-100 text-green-800';
        case 'In Progress': return 'bg-blue-100 text-blue-800';
        case 'Delayed': return 'bg-red-100 text-red-800';
        default: return 'bg-yellow-100 text-yellow-800';
    }
}

export default RGPForm;